module.exports = __webpack_public_path__ + "static/media/4-min.ccb5e843.png";